import { SkeletonLoader } from "@whoosh/design-system/src/components/display";
import { HStack, VStack } from "@whoosh/design-system/src/components/primitive";

export const PackageDetailSkeleton = () => {
  return (
    <VStack px={6} gap={4}>
      <HStack justifyContent="space-between" alignItems="center">
        <SkeletonLoader height={18} width={80} borderRadius="2" />
        <SkeletonLoader height={18} width={50} borderRadius="2" />
      </HStack>
      <HStack justifyContent="space-between" alignItems="center">
        <SkeletonLoader height={18} width={100} borderRadius="2" />
        <SkeletonLoader height={18} width={60} borderRadius="2" />
      </HStack>
      <HStack justifyContent="space-between" alignItems="center">
        <SkeletonLoader height={18} width={120} borderRadius="2" />
        <SkeletonLoader height={18} width={60} borderRadius="2" />
      </HStack>
      <HStack justifyContent="space-between" alignItems="center">
        <SkeletonLoader height={18} width={60} borderRadius="2" />
        <SkeletonLoader height={18} width={80} borderRadius="2" />
      </HStack>
    </VStack>
  );
};
